import { Empty, lucideIcons } from '@round/creatorbase-ui';
import styles from './TableEmptyState.module.css';

const { SearchX, CircleAlert } = lucideIcons;

type Props = {
    isError?: boolean;
    title?: string;
    description?: string;
};

const TableEmptyState = ({ isError, title, description }: Props) => {
    const Icon = isError ? CircleAlert : SearchX;

    return (
        <Empty className={styles.empty}>
            <Empty.Media variant="icon">
                <Icon />
            </Empty.Media>
            {title && <Empty.Title>{title}</Empty.Title>}
            {description && <Empty.Description>{description}</Empty.Description>}
        </Empty>
    );
};

export default TableEmptyState;
